import { IButton } from '@dazn/lp-web/src/types/common.types';
import { chapters, navigateToDifferentChapterUrl } from '@dazn/lp-web/src/utils';
import { ComponentTypes } from '../constants/componentTypes.constants';
export function buttonProxy(buttonFields: IButton): IButton {
    if (!buttonFields) return {} as IButton;

    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const handleActionClick = (action: IButton) => {
        const {
            navigationType, // will be either Internal or External
            navigationChapterName, // will be the name of the chapterName to be redirected
            navigationLink, // is ChapterPath
            navigationInfo, // to be included in ChapterData
            entitlementSetId,
            billingPeriod,
            promoCode,
            scrollAction
        } = action;
        const chapterData = {
            ...(entitlementSetId ? { entitlementSetId } : {}),
            ...(billingPeriod ? { billingPeriod } : {}),
            ...(navigationInfo ? navigationInfo : {}),
            ...(promoCode ? { promoCode } : {})
        };

        const scrollMapping = {
            ScrollToCompitionsRails: ComponentTypes.COMPETITION_CAROUSEL,
            ScrollToTier: ComponentTypes.CONTENT_TIERS
        };

        if (navigationType === 'External') {
            window.open(action?.navigationLink, '_blank');
            return;
        }

        if (scrollAction && scrollAction in scrollMapping) {
            scrollToSection(
                scrollMapping[scrollAction as keyof typeof scrollMapping]
            );
            return;
        }

        if (navigationChapterName?.toLowerCase() === chapters.CATALOG) {
            if (navigationLink) {
                navigateToDifferentChapterUrl({
                    chapterName: navigationChapterName,
                    chapterPath: navigationLink,
                    chapterData: {}
                });
            }
            return;
        }

        if (navigationChapterName) {
            navigateToDifferentChapterUrl({
                chapterName: navigationChapterName,
                chapterPath: navigationLink,
                chapterData
            });
            return;
        }

        if (navigationLink) {
            window.open(action?.navigationLink, '_self');
            return;
        }
    };

    return {
        ...buttonFields,
        entitlementSetId: buttonFields?.entitlementSetId,
        action: (buttonProps) => {
            handleActionClick({ ...buttonFields, ...(buttonProps ?? {}) });
        }
    };
}
